import types from '../../mutation-types';
import * as Sentry from '@sentry/vue';

export const mutations = {
  [types.SET_CLIENT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_CLIENTS]: $state => {
    $state.records = {};
    $state.sortOrder = [];
  },

  [types.SET_CLIENT_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    $state.meta.count = count;
    $state.meta.currentPage = currentPage;
  },

  [types.SET_CLIENTS]: ($state, data) => {
    const sortOrder = data.map(client => {
      $state.records[client.id] = {
        ...($state.records[client.id] || {}),
        ...client,
      };
      return client.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_CLIENT_ITEM]: ($state, data) => {
    $state.records[data.id] = {
      ...($state.records[data.id] || {}),
      ...data,
    };

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.EDIT_CLIENT]: ($state, data) => {
    $state.records[data.id] = data;
  },

  [types.DELETE_CLIENT]: ($state, id) => {
    const index = $state.sortOrder.findIndex(item => item === id);
    $state.sortOrder.splice(index, 1);
    delete $state.records[id];
  },

  [types.UPDATE_CLIENTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach(element => {
      let availabilityStatus;
      try {
        availabilityStatus = data[element.id];
      } catch (error) {
        Sentry.setContext('client is undefined', {
          records: $state.records,
          data: data,
        });
        Sentry.captureException(error);

        return;
      }
      if (availabilityStatus) {
        $state.records[element.id].availability_status = availabilityStatus;
      } else {
        $state.records[element.id].availability_status = null;
      }
    });
  },

  [types.SET_CLIENT_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_CLIENT_FILTERS](_state) {
    _state.appliedFilters = [];
  },
};
